import { spaces } from '@99designs/common/core/settings';
import { getComponentClasses } from '@99designs/common/utils/app';
import Heading from 'common/components/Heading';
import { Figure } from 'common/components/Image';
import 'lazysizes';
import React from 'react';
import { PlaceHolderImage } from './PlaceHolderImage';

interface Props {
    variations?: string[];
    src?: string;
    alt?: string;
    width?: number;
    height?: number;
    ribbon?: React.ReactNode;
    attribution?: React.ReactNode;
    placeholderMessage?: string;
    designMetaContent?: React.ReactNode;
    lazyload?: boolean;
}

export default function DesignCard({
    variations = [],
    src,
    alt,
    width,
    height,
    ribbon,
    attribution,
    placeholderMessage,
    designMetaContent,
    lazyload = true,
}: Props) {
    if (!src) {
        variations.push('placeholder');
    }

    const className = getComponentClasses('bundle-design-card', variations);

    return (
        <div className={className}>
            {ribbon && <div className="bundle-design-card__ribbon">{ribbon}</div>}

            <div className="bundle-design-card__placeholder">
                <div className="bundle-design-card__placeholder__inner">
                    <PlaceHolderImage
                        width={84}
                        height={84}
                        style={{ marginBottom: placeholderMessage ? spaces.space8 : 0 }}
                    />

                    {!src && placeholderMessage && (
                        <Heading size="h5" variations={['h5', 'no-margin']}>
                            {placeholderMessage}
                        </Heading>
                    )}
                </div>
            </div>

            {src ? (
                <div
                    className="bundle-design-card__image"
                    style={{ maxHeight: height, maxWidth: width }}
                >
                    <Figure
                        src={src}
                        alt={alt}
                        width={width}
                        height={height}
                        caption={designMetaContent}
                        lazyload={lazyload}
                    />
                </div>
            ) : (
                <div
                    className="bundle-design-card__image"
                    style={{ maxHeight: height, maxWidth: width }}
                />
            )}

            {attribution && <div className="bundle-design-card__attribution">{attribution}</div>}
        </div>
    );
}
